import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import MonthlyReport from '../components/MonthlyReport';
import { ShieldAlert } from 'lucide-react';

const Reports = () => {
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    return (
      <div className="panel text-center py-12">
        <ShieldAlert className="w-7 h-7 text-gray-400 mx-auto mb-2" />
        <h1 className="text-base font-semibold text-gray-900">Access denied</h1>
        <p className="text-subtle text-sm mt-1">
          You don't have permission to access reports.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="page-header flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div>
          <h1 className="page-title">Reports</h1>
          <p className="page-subtitle">Monthly attendance reports, summaries, and CSV exports.</p>
        </div>
      </div>

      <MonthlyReport />
    </div>
  );
};

export default Reports;
